const getSkeletonCount = (pageSize, recordCount, min) =>
	Math.max(Math.min(pageSize, recordCount), min);

export {
	getSkeletonCount
}